import { combineActions, handleActions } from 'redux-actions';

import type { AsyncDispatch } from '../../utils/redux-store/asyncDispatchMiddleware';
import { resourceStoreTypes, resourceUndoUpserters, resourceUpserters } from '../core';
import * as actions from './alertRulesActions';
import type { AlertRuleProps } from './alertRulesTypes';

const QcsSyncAlertRulesStoreFactory = resourceStoreTypes.createTypedQcsSyncResourceStoreFactory<AlertRuleProps>();
const alertRulesReducer = handleActions<
  resourceStoreTypes.QcsSyncResourceStore<AlertRuleProps>,
  | ReturnType<typeof actions.getAlertRulesSuccess>
  | ReturnType<typeof actions.updateAlertRule>
  | ReturnType<typeof actions.updateAlertRuleSuccess>
  | ReturnType<typeof actions.getAlertRulesFailure>
  | ReturnType<typeof actions.batchAlertRules>
  | ReturnType<typeof actions.batchAlertRulesSuccess>
>(
  {
    [actions.getAlertRulesSuccess.type]: (state, { payload: data }) => resourceUpserters.upsertResources(state, data),

    [actions.updateAlertRule.type]: (state, action) =>
      resourceUndoUpserters.upsertResourceSetupUndo(state, action, actions.updateAlertRule),
    [actions.updateAlertRuleSuccess.type]: (state, { payload }) => resourceUpserters.upsertResource(state, payload),

    [actions.batchAlertRules.type]: (state, action) =>
      resourceUndoUpserters.upsertResourcesSetupUndo(state, action, actions.batchAlertRules, false),
    [actions.batchAlertRulesSuccess.type]: (state, action) =>
      resourceUndoUpserters.upsertResourcesSetupUndo(state, action, actions.batchAlertRules, true),

    [actions.getAlertRulesFailure.type]: (state, { payload: error }) =>
      resourceUpserters.completeWithError(state, error),

    [combineActions(actions.updateAlertRuleFailure, actions.batchAlertRulesFailure).toString()]: (
      state: resourceStoreTypes.QcsSyncResourceStore<AlertRuleProps>,
      { payload: error, asyncDispatch }: { payload: unknown; asyncDispatch: AsyncDispatch },
    ) => {
      asyncDispatch(actions.getAlertRules());
      return resourceUpserters.resetResources(state, error);
    },
  },
  QcsSyncAlertRulesStoreFactory({ resourceName: 'alertRule' }),
);

export default alertRulesReducer;
